module.exports = __webpack_public_path__ + "img/PCT13.51fb0feb.svg";